import { SparkleLoader } from '../../../../common/SparkleLoader'
import { AVATAR_COLOR, getInitials } from '../../../../../features/stakeholder'
import type { PortraitDisplayProps } from '../CharacterSelectionModal.types'
import {
  CardPortraitContainer,
  CardPortraitInner,
  CardPortraitImage,
  CardPortraitInitials,
  SlotPortrait,
  SlotPortraitImage,
  SlotInitials,
  ProfilePortraitLarge,
  ProfilePortraitImage,
  ProfilePortraitInitials,
} from '../styles/CharacterSelectionModalStyles'

export function PortraitDisplay({
  template,
  size,
  brokenPortraits,
  markPortraitBroken,
  isGenerating,
}: PortraitDisplayProps) {
  const portraitUrl = template.portrait_url ?? undefined
  const hasPortrait = portraitUrl && !brokenPortraits.has(template.id)

  if (size === 'card') {
    return (
      <CardPortraitContainer $color={AVATAR_COLOR}>
        <CardPortraitInner>
          {hasPortrait ? (
            <CardPortraitImage
              src={portraitUrl}
              alt={template.name}
              onError={() => markPortraitBroken(template.id)}
            />
          ) : isGenerating ? (
            <SparkleLoader isAnimating={true} size={64} />
          ) : (
            <CardPortraitInitials>{getInitials(template.name)}</CardPortraitInitials>
          )}
        </CardPortraitInner>
      </CardPortraitContainer>
    )
  }

  if (size === 'slot') {
    return (
      <SlotPortrait $color={AVATAR_COLOR}>
        {hasPortrait ? (
          <SlotPortraitImage
            src={portraitUrl}
            alt={template.name}
            onError={() => markPortraitBroken(template.id)}
          />
        ) : isGenerating ? (
          <SparkleLoader isAnimating={true} size={32} />
        ) : (
          <SlotInitials>{getInitials(template.name)}</SlotInitials>
        )}
      </SlotPortrait>
    )
  }

  // size === 'large'
  return (
    <ProfilePortraitLarge $color={AVATAR_COLOR}>
      {hasPortrait ? (
        <ProfilePortraitImage
          src={portraitUrl}
          alt={template.name}
          onError={() => markPortraitBroken(template.id)}
        />
      ) : isGenerating ? (
        <SparkleLoader isAnimating={true} size={96} />
      ) : (
        <ProfilePortraitInitials>{getInitials(template.name)}</ProfilePortraitInitials>
      )}
    </ProfilePortraitLarge>
  )
}
